import { Button } from "@hireart/component-library";
import PropTypes from "prop-types";
import { DrawerFooter, DrawerClose } from "common/components/Drawer";

export const ShiftFooter = ({
  isReadOnly,
  isMobile,
  onSave,
  isSaving = false,
  isSaveDisabled = false,
}) => {
  const footerClassName =
    "border-t border-neutral-20 p-16 bg-neutral-10 shrink-0";
  const footerStyle = isMobile
    ? {
        // Add padding to clear mobile browser chrome
        paddingBottom: `calc(40px + env(safe-area-inset-bottom))`,
      }
    : {};

  return (
    <DrawerFooter className={footerClassName} style={footerStyle}>
      <div className="flex w-full flex-col gap-8 sm:flex-row">
        {isReadOnly ? (
          <DrawerClose asChild>
            <Button
              color="secondary"
              className="flex w-full items-center justify-center sm:ml-auto sm:w-auto"
              size="lg"
              type="button"
            >
              Close
            </Button>
          </DrawerClose>
        ) : (
          <div className="flex w-full flex-col gap-8 sm:flex-row sm:justify-end">
            <DrawerClose asChild>
              <Button
                color="secondary"
                className="flex w-full items-center justify-center sm:w-auto"
                size="lg"
                type="button"
              >
                Cancel
              </Button>
            </DrawerClose>
            <Button
              color="primary-green"
              className="flex w-full items-center justify-center sm:w-auto"
              size="lg"
              type="button"
              onClick={onSave}
              isLoading={isSaving}
              isDisabled={isSaving || isSaveDisabled}
            >
              Save shift
            </Button>
          </div>
        )}
      </div>
    </DrawerFooter>
  );
};

ShiftFooter.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isSaveDisabled: PropTypes.bool,
};
